document.addEventListener('DOMContentLoaded', function () {
  const burgerBtn = document.querySelector('.header-burger');
  const mobileMenu = document.querySelector('.header-mobile-menu');
  const closeBtn = document.querySelector('.header-mobile-close');
  const navLinks = document.querySelectorAll('.header-mobile-nav .header-nav-link');

  // Відкрити меню
  burgerBtn.addEventListener('click', function () {
    mobileMenu.classList.add('active');
    document.body.classList.add('noscroll');
  });

  // Закрити меню
  closeBtn.addEventListener('click', function () {
    mobileMenu.classList.remove('active');
    document.body.classList.remove('noscroll');
  });

  // Клік по кожному пункту меню
  navLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      // прибираємо активний клас у всіх
      navLinks.forEach(l => l.classList.remove('active'));
      // додаємо активний клас на поточний
      link.classList.add('active');

      // закриваємо меню
      mobileMenu.classList.remove('active');
      document.body.classList.remove('noscroll');

      // плавний скрол до секції
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const section = document.querySelector(href);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});